import { defineMessages } from 'react-intl';
var messages = defineMessages({
    title: {
        defaultMessage: 'Alle Artikel anzeigen',
        id: 'search.page.title',
    },
});
export default messages;
